import {
  FileText,
  HandHeart,
  HeartPulse,
  Scale,
  ShieldCheck,
  Sprout,
  Users,
  Wallet,
  type LucideIcon,
} from 'lucide-react'
import { slugForDepartment } from '../lib/departments.ts'

/**
 * One glyph per department, keyed by slug so the sidebar rail and the catalog
 * cards cannot drift into showing different icons for the same place.
 *
 * Each is chosen for what the department does rather than for decoration: the
 * scales weigh a service against the Regulations, the sprout is growth (an
 * early years reading of Educational Leadership rather than a mortarboard),
 * and the shield is protection. Seven identical building glyphs told a reader
 * nothing, which is what this replaces.
 */
const BY_SLUG: Record<string, LucideIcon> = {
  'governance-compliance': Scale,
  'people-culture': Users,
  'child-safety': ShieldCheck,
  'health-safety-wellbeing': HeartPulse,
  'educational-leadership': Sprout,
  'family-community-engagement': HandHeart,
  'finance-operations': Wallet,
}

/**
 * Accepts either a slug or a department name, because the rail holds slugs and
 * a catalog card holds the name. Anything unrecognised (a bespoke tool with a
 * department of its own) falls back to a plain sheet.
 */
export function iconForDepartment(nameOrSlug: string): LucideIcon {
  return BY_SLUG[nameOrSlug] ?? BY_SLUG[slugForDepartment(nameOrSlug)] ?? FileText
}

export function DepartmentIcon({
  department,
  size = 22,
  strokeWidth = 2,
}: {
  department: string
  size?: number
  strokeWidth?: number
}) {
  const Glyph = iconForDepartment(department)
  return <Glyph size={size} strokeWidth={strokeWidth} />
}
